export default "__VITE_ASSET__5b3b6cf0__"